<template>
	<DrawerPanel
		ref="drawer"
		title=""
		bottom="-32px"
		:blurBackground="true"
		:closeBackground="false"
		:openHeight="openHeight"
		closedHeight="0px"
		:startOpened="false"
		:close="true"
		:divider="false"
		backgroundColor="#FFFFFF"
		openBackgroundColor="#F9F7F3;"
	>
		<div class="quiz-intro-drawer">
			<div class="quiz-intro-header">
				<div class="quiz-intro-content">
					<h2 class="quiz-intro-title">{{ heading }}</h2>
					<p class="quiz-intro-subtitle">{{ headingDescription }}</p>
				</div>
				
				<div class="quiz-intro-image">
					<img :src="require('@/assets/quiz/quiz-default-bg.png')" alt="Quiz" />
				</div>
			</div>
			
			<div class="quiz-intro-footer">
				<p class="quiz-intro-description">
					{{ rulesDescription }}
				</p>
				
				<div class="quiz-notifications">
					<p class="quiz-notifications-title">Keep reminders on to keep up your streak!</p>
						<div class="quiz-notifications-toggle">
							<span class="toggle-label">Notifications:</span>
							<div class="toggle-control">
							<span class="toggle-text" :class="{ 'active': !notificationsEnabled }">Off</span>
							<div class="toggle-switch" :class="{ 'toggle-on': notificationsEnabled }" @click="toggleNotifications">
								<div class="toggle-knob"></div>
							</div>
							<span class="toggle-text" :class="{ 'active': notificationsEnabled }">On</span>
						</div>
					</div>
				</div>
				
				<a href="#" class="quiz-terms-link" @click.prevent="$emit('terms-click')">Terms & Conditions</a>
			</div>
		</div>
	</DrawerPanel>
</template>

<script>
import DrawerPanel from './DrawerPanel.vue';

export default {
	name: 'QuizDrawerRulesPanel',
    props: {
        openHeight: {
            type: String,
            default: '80%'
        },
		quiz: {
			type: Object,
			required: false
		},
		customer: {
			type: Object,
			required: false
		}
    },
	computed: {
		heading() {
			return this.quiz.advertisingHeader;
		},
		headingDescription() {
			return this.quiz.advertisingDescription;
		},
		rulesDescription() {
			var rulesDescription = "Play for " + this.quiz.streakMeterMax + " days to get " + this.quiz.streakMeterMax + " bonus entries to the prize draw.";
			return rulesDescription;
		},
		notificationsEnabled: {
			get() {
				return this.customer?.preferences?.quizNotifications ?? true;
			},
			set(value) {
				// Emit to parent to handle saving
				this.$emit('notifications-change', value);
			}
		}
	},
	components: {
		DrawerPanel
	},
	emits: ['terms-click', 'notifications-change'],
	methods: {
		openDrawer() {
			this.$refs.drawer.openDrawer();
		},
		closeDrawer() {
			this.$refs.drawer.closeDrawer();
		},
		toggleNotifications() {
			this.notificationsEnabled = !this.notificationsEnabled;
		}
	}
}
</script>

<style scoped>
/* Quiz Intro Drawer Styles */
.quiz-intro-drawer {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 0;
	margin: 0 -20px;
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
}

.quiz-intro-header {
	width: 100%;
	min-height: 320px;
	background: #F9F7F3;
	display: flex;
	flex-direction: column;
	position: relative;
	flex-shrink: 0;
}

.quiz-intro-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
	padding: 10px 40px 0;
	z-index: 1;
}

.quiz-intro-title {
	font-weight: bold;
	font-size: 24px;
	line-height: 1.167em;
	text-align: center;
	color: #413655;
	margin: 0;
}

.quiz-intro-subtitle {
	font-weight: bold;
	font-size: 16px;
	line-height: 1.25em;
	text-align: center;
	color: #413655;
	margin: 0;
	max-width: 257px;
}

.quiz-intro-image {
	margin: 40px 20px 0;
	border-radius: 10px;
	overflow: hidden;
	background: #5A506E;
	flex-shrink: 0;
	max-height: 240px;
}

.quiz-intro-image img {
	width: 100%;
	height: auto;
	max-height: 240px;
	display: block;
	object-fit: cover;
}

.quiz-intro-footer {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding: 20px 20px calc(60px + env(safe-area-inset-bottom));
	background: #FFFFFF;
	flex-shrink: 0;
}

.quiz-intro-description {
	font-weight: bold;
	font-size: 15px;
	line-height: 1.467em;
	text-align: center;
	color: #413655;
	margin: 0;
	max-width: 271px;
}

.quiz-notifications {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: -21px;
}

.quiz-notifications-title {
	font-weight: bold;
	font-size: 15px;
	line-height: 1.467em;
	text-align: center;
	color: #413655;
	margin: 0;
}

.quiz-notifications-toggle {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 194px;
}

.toggle-label {
	font-weight: 400;
	font-size: 15px;
	line-height: 1.467em;
	color: #413655;
}

.toggle-control {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-left: 8px;
}

.toggle-text {
	font-weight: normal !important;
	font-size: 15px;
	line-height: 1.467em;
	color: #413655 !important;
	background: none !important;
	background-color: transparent !important;
}

.toggle-text.active {
	font-weight: bold !important;
	background: none !important;
	background-color: transparent !important;
}

.toggle-switch {
	width: 26px;
	height: 15px;
	background: linear-gradient(180deg, rgba(102, 102, 102, 1) 0%, rgba(102, 102, 102, 0) 68%), #478CF6;
	border-radius: 11px;
	position: relative;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: inset 0px 0.5px 2.5px 0px rgba(102, 102, 102, 0.75);
}

.toggle-switch.toggle-on .toggle-knob {
	transform: translateX(11px);
}

.toggle-knob {
	position: absolute;
	left: 1px;
	top: 1px;
	width: 13px;
	height: 13px;
	background: #FFFFFF;
	border: 0.5px solid rgba(0, 0, 0, 0.02);
	border-radius: 100px;
	transition: transform 0.3s ease;
	box-shadow: 0px 0.2px 0.25px 0px rgba(0, 0, 0, 0.12);
}

.quiz-terms-link {
	font-weight: bold;
	font-size: 13px;
	line-height: 1.231em;
	text-align: center;
	color: #413655;
	text-decoration: none;
	padding: 8px 16px;
	border-radius: 100px;
	cursor: pointer;
}

.quiz-terms-link:hover {
	opacity: 0.8;
}

/* Responsive adjustments for narrow screens (foldables) */
@media (max-width: 380px) {
	.quiz-intro-header {
		min-height: 260px;
	}

	.quiz-intro-content {
		padding: 20px 20px 0;
		gap: 4px;
	}

	.quiz-intro-title {
		font-size: 20px;
	}

	.quiz-intro-subtitle {
		font-size: 14px;
	}

	.quiz-intro-image {
		margin: 20px 15px 0;
		max-height: 160px;
	}

	.quiz-intro-image img {
		max-height: 160px;
	}

	.quiz-intro-footer {
		padding: 16px 16px calc(60px + env(safe-area-inset-bottom));
		gap: 16px;
	}

	.quiz-intro-description {
		font-size: 14px;
	}

	.quiz-notifications {
		width: 100%;
		max-width: 100%;
		padding: 0 10px;
	}

	.quiz-notifications-title {
		font-size: 13px;
	}

	.toggle-label,
	.toggle-text {
		font-size: 14px;
	}
}
</style>
